import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditCatalogInstitutions from './EditCatalogInstitutions'
import ListCatalogInstitutions from './ListCatalogInstitutions'
import NewCatalogInstitutions from './NewCatalogInstitutions'

const AdminCatalogInstitutionsRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListCatalogInstitutions /></PrivateRoute7>} />
        <Route path="edit-institution" element={<PrivateRoute7><EditCatalogInstitutions /></PrivateRoute7>} />
        <Route path="new-institution" element={<PrivateRoute7><NewCatalogInstitutions /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminCatalogInstitutionsRoutes